import request from "../utils/request";

export function getHomeworkList(subject, pageNum, pageSize, classId) {
  let url = "/zhx/teacher/api/jiangping/getHomeworkList?";

  // 根据参数是否为 undefined 来构建 URL
  if (subject) {
    url += "subject=" + encodeURIComponent(subject) + "&";
  }
  if (classId) {
    url += "classId=" + encodeURIComponent(classId) + "&";
  }
  if (pageNum) {
    url += "pageNum=" + pageNum + "&";
  }
  if (pageSize) {
    url += "pageSize=" + pageSize + "&";
  }

  // 去掉最后一个多余的 &
  url = url.endsWith("&") ? url.slice(0, -1) : url;

  return request({
    url: url,
    method: "get"
  });
}

export function getExamQuesList(homeworkId, classId) {
  return request({
    url:
      "/zhx/teacher/api/jiangping/getExamQuesList?homeworkId=" +
      homeworkId +
      "&classId=" +
      classId,
    method: "get"
  });
}

export function getStudentAnswerInfo(homeworkId, classId, questionId) {
  return request({
    url:
      "/zhx/teacher/api/jiangping/getStudentAnswerInfo?homeworkId=" +
      homeworkId +
      "&classId=" +
      classId +
      "&questionId=" +
      questionId,
    method: "get"
  });
}

export function getStudentAnswerInfo2Api(
  scanId,
  classId,
  sourceId,
  questionId
) {
  return request({
    url:
      "/zhx/teacher/api/jiangping/getWrongUserMap?scanId=" +
      scanId +
      "&classId=" +
      classId +
      "&sourceId=" +
      sourceId +
      "&questionId=" +
      questionId,
    method: "get"
  });
}

export function html2image(urlBase64, refresh, fileName) {
  return request({
    url: "/zhx/api/common/html2image",
    method: "get",
    params: {
      url: urlBase64,
      refresh: refresh,
      imageStorePath: "question",
      imageFileName: fileName
    }
  });
}

export function getAccuracyApi(scanId, classId, sourceId, chapterId) {
  return request({
    url: `/zhx/teacher/api/jiangping/getSourceQuesList?scanId=${scanId}&classId=${classId}&sourceId=${sourceId}${chapterId ? `&chapterId=${chapterId}` : ''}`,
    method: "get"
  });
}



export function getHomeworkApi(homeworkId) {
  return request({
    url: `/zhx/teacher/api/jiangping/getHomework?homeworkId=${homeworkId}`,
    method: "get"
  });
}
export function getAllSubjectsApi() {
  return request({
    url: `/zhx/api/common/getAllSubjects`,
    method: "get"
  });
}


// WEBPACK FOOTER //
// ./src/apis/explainApi.js